import { NavController, Events, NavParams, Loading } from 'ionic-angular'
import { Component } from '@angular/core'
import { DetailPage } from '../itinerary/detail'
import { Minutes } from '../../pipes/minutes'
import { DatetimeToDate } from '../../pipes/datetime'

@Component({
  templateUrl: 'build/pages/itinerary/choice.html',
  pipes: [Minutes, DatetimeToDate]
})
export class ChoicePage {
  private start: any
  private end: any
  private journeys: any = Array

  constructor(private nav: NavController, private events: Events, params: NavParams) {
    let journeys = params.get('data').journeys;
    this.start = params.get('start');
    this.end = params.get('end');

    this.parseWalk(journeys);

    this.journeys = journeys;
  }

  parseWalk(journeys) {
    for (let journey of journeys) {
      let walk = 0;

      for (let section of journey.sections) {
        if (section.type === 'street_network') {
          if (section.duration > 1) {
            walk += section.duration;
          }
        }
      }

      journey.walk = walk;
    }
  }

  detail(journey) {
    this.nav.push(DetailPage, {
      journey,
      start: this.start,
      end: this.end
    })
  }
}
